<div class="tt-smartbook-footer_mobile-menu">
  <button ttButton variant="secondary" (click)="handleMobileMenuClick()">
    <mat-icon [icon]="'menu'" [iconSize]="16" />
    @if (isMenuOpen()) {
      <span>{{ 'Close' | transloco }}</span>
    }
    @if (!isMenuOpen()) {
      <span>{{ 'Content' | transloco }}</span>
    }
  </button>
</div>

<div class="tt-smartbook-footer_version">
  <mat-icon [icon]="'info'" [iconSize]="16" />
  <span>
    <span class="tt-smartbook-footer_label">{{ 'Version' | transloco }}</span>
    <span class="tt-smartbook-footer_bold">{{ version() }}</span>
  </span>
  @if (publishedAt()) {
    <span>
      <span class="tt-smartbook-footer_label">{{ 'PublishedAt' | transloco }}</span>
      <span class="tt-smartbook-footer_bold">
        {{ publishedAt() | addZToUTC | translocoDate }}
      </span>
    </span>
  }
</div>

<div class="tt-smartbook-footer_center">
  <button
    data-testid="smartbook-footer_button-default-view"
    emphasis="minimal"
    ttButton
    variant="secondary"
    [ttTooltip]="'DefaultView' | transloco"
    (click)="handleDefaultViewClicked()">
    <mat-icon [icon]="'restore'" [iconSize]="16" />
    <span class="tt-smartbook-footer_button-label">{{ 'DefaultView' | transloco }}</span>
  </button>
  <expand-collapse-toggle />
  <tt-comments-footer-button />
  @if (canExportPdf()) {
    <button
      data-testid="smartbook-footer_button-export-pdf"
      emphasis="minimal"
      ttButton
      variant="secondary"
      [ttTooltip]="'ExportGuidelineToPdf' | transloco"
      (click)="handleExportPdfClicked()">
      <mat-icon [icon]="'file-pdf'" [iconSize]="16" />
      <span class="tt-smartbook-footer_button-label">{{ 'ExportGuidelineToPdf' | transloco }}</span>
    </button>
  }
  @if (canExportHtml()) {
    <button
      data-testid="smartbook-footer_button-export-html"
      emphasis="minimal"
      ttButton
      variant="secondary"
      [ttTooltip]="'ExportGuidelineToHtml' | transloco"
      (click)="handleExportHtmlClicked()">
      <mat-icon [icon]="'file-code-2'" [iconSize]="16" />
      <span class="tt-smartbook-footer_button-label">{{ 'ExportGuidelineToHtml' | transloco }}</span>
    </button>
  }
  @if (canImportGuideline()) {
    <button
      data-testid="smartbook-footer_button-import"
      emphasis="minimal"
      ttButton
      variant="secondary"
      [ttTooltip]="'ImportGuidelineDialog.Import' | transloco"
      (click)="handleImportClicked()">
      <mat-icon [icon]="'import'" [iconSize]="16" />
      <span class="tt-smartbook-footer_button-label">{{ 'ImportGuidelineDialog.Import' | transloco }}</span>
    </button>
  }
</div>

<div class="tt-smartbook-footer_actions">
  @if (!isPublicPage()) {
    <button data-testid="smartbook-footer_button-close" ttButton variant="primary" (click)="handleClose()">
      <mat-icon [icon]="'x'" [iconSize]="16" />
      <span>{{ 'Close' | transloco }}</span>
    </button>
  }
</div>
